<template>
  <div class="g-bd">
    <div class="con-menu">
      <div class="con-nav-list">
        <div class="pos-flex" v-if="posFlag&&indexBanner" :title="indexBanner.title">
          <div class="pos-con">
            <div class="pos-close" @click="posFlag = false">
              <i class="el-icon-circle-close"></i>
            </div>
            <div class="pos-msg" @click="toIndexBannerLink()">
              <img :src="imgUrl + indexBanner.path" alt="">
            </div>
          </div>
        </div>
        <ul @mouseleave="getClear()">
          <li
            :index="item.id"
            v-for="(item, index) in categoryOptions"
            :key="index + 'a'"
            v-if="item.id != ''"
            @click="openCourse(item.id)"
          >
            <span slot="title">{{ item.title }}</span>
          </li>
          <li
            :index="item.id"
            v-for="(item, index) in categoryOptions"
            :key="index + 'a'"
            v-if="item.id == ''"
            @mouseover="getAll()"
            @click="getDelMenu()"
          >
            <span slot="title">更多</span>
            <i
              :class="iconFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></i>
          </li>
        </ul>
      </div>
      <div class="pos-black-bg"></div>
      <div class="pos-black">
        <div class="pos-news">
          <ul>
            <div class="pos-title">
              <h3>资讯</h3>
              <span @click="toNewsList">更多 &gt;</span>
            </div>
            <li v-for="item in newsList" :key="item.id">
              <a
                :href="`/news/newsDetail?id=${item.id}`"
                :title="item.title"
                target="_blank"
                >{{ item.title }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- banner -->
    <div class="con-banner">
      <el-carousel trigger="click" height="400px" arrow="never">
        <a
          :href="item.linkUrl ? `${item.linkUrl}` : 'javascript:void(0);'"
          v-for="item in bannerList"
          :key="item.id"
          :target="item.linkUrl ? '_blank' : '_self'"
        >
          <el-carousel-item
            :style="`background:${item.backgroundColor};background-size: cover;
-webkit-background-size: cover;
-o-background-size: cover;
zoom: 1;`"
          >
            <div class="item-con">
              <img :src="imgUrl + item.path" alt />
            </div>
          </el-carousel-item>
        </a>
      </el-carousel>
    </div>
    <!-- 子站 -->
    <div class="child-body">
      <div class="child-box">
        <div class="child-content">
          <ul>
            <!-- listTag -->
              <!-- class="child-type1" -->
            <li
              v-for="(item,i) in listTag"
              v-if="i<4"
              :key="i"
              :title="item.title"
              @click="item.status == 1?toChildIndex(i+2):toTagIndex()"
            >
            <img :src="imgUrl + item.image" alt="" />
            </li>
            <!-- <li
              class="child-type1"
              title="高等本科"
              @click="toChildIndex(2)"
            ></li>
            <li
              class="child-type2"
              title="职业教育"
              @click="toChildIndex(3)"
            ></li>
            <li class="child-type3">
            </li>
            <li class="child-type4">
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- 乡村振兴 -->
    <div class="rural-promote" @click="toChildIndex(6)">
      <img src="/images/rural-promote.png" alt="" />
    </div>
    <div class="con-banner subjectList" v-if="subjectList && subjectList.length>0">
      <el-carousel trigger="click" height="100px" arrow="never">
        <a
          :href="item.linkUrl ? `${item.linkUrl}` : 'javascript:void(0);'"
          v-for="item in subjectList"
          :key="item.id"
          :target="item.linkUrl ? '_blank' : '_self'"
        >
          <el-carousel-item
            :style="`background:${item.backgroundColor};background-size: cover;
-webkit-background-size: cover;
-o-background-size: cover;
zoom: 1;`"
          >
            <div class="item-con">
              <img :src="imgUrl + item.path" alt />
            </div>
          </el-carousel-item>
        </a>
      </el-carousel>
    </div>
    <!-- 院校 -->
    <div class="school-body f-clearfix" v-if="!!schoolFlag">
      <div class="school-box f-clearfix">
        <div class="school-content f-clearfix">
          <school ref="school" @getSchool="getSchool"></school>
        </div>
      </div>
    </div>
    <!-- 直播 -->
    <div class="course-body" v-if="liveFlag">
      <div class="course-box">
        <div class="body-tool course-tool">
          <h2>直播预告</h2>
        </div>
        <div class="course-content">
          <live @getlive="getlive"></live>
        </div>
      </div>
    </div>
    <!-- 热门课程 TODO-->
    <div class="hotCourse-body" v-if="!!recommendFlag">
      <div class="hotCourse-box">
        <div class="hotCourse-content">
          <recommend @getRecommend="getRecommend"></recommend>
        </div>
      </div>
    </div>
    <!-- 热门名师 -->
    <div class="hotTeacher-body" v-if="!!teacherFlag">
      <div class="hotTeacher-box">
        <div class="body-tool hotTeacher-tool">
          <h2>热门名师</h2>
          <span @click="toTeacherList">更多名师 &gt;</span>
        </div>
        <div class="hotTeacher-content">
          <hotTeacher ref="hotTeacher" @getTeacher="getTeacher"></hotTeacher>
        </div>
      </div>
    </div>
    <!-- 排行榜 -->
    <div class="slort-body">
      <div class="slort-box">
        <div class="body-tool slort-tool">
          <h2>排行榜</h2>
        </div>
        <div class="slort-content">
          <rankSchool class="rank-box"></rankSchool>
          <rankCourse class="rank-box"></rankCourse>
          <rankTeacher class="rank-box"></rankTeacher>
          <!-- <rankStudent class="rank-box"></rankStudent> -->
        </div>
      </div>
    </div>
    <!-- 统计 -->
    <div class="data-count">
      <div class="data-body">
        <ul class="f-clearfix">
          <li class="f-clearfix">
            <div class="item-icon item-icon1"></div>
            <div class="item-border">
              {{ dataCounts.register }}<span class="item-title">人</span>
            </div>
            <div class="item-title">学生总数</div>
          </li>
          <li>
            <div class="item-icon item-icon2"></div>
            <div class="item-border">
              {{ dataCounts.teacher }}<span class="item-title">位</span>
            </div>
            <div class="item-title">讲师总数</div>
          </li>
          <li>
            <div class="item-icon item-icon3"></div>
            <div class="item-border">
              {{ dataCounts.university }}
              <span class="item-title">所</span>
            </div>
            <div class="item-title">学校总数</div>
          </li>
          <li>
            <div class="item-icon item-icon4"></div>
            <div class="item-border item-noborder">
              {{ dataCounts.course }}
              <span class="item-title">门</span>
            </div>
            <div class="item-title">课程总数</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import school from "./school.vue";
import live from "./live.vue";
import hotCourse from "./hotCourse.vue";
import hotTeacher from "./hotTeacher.vue";
import recommend from "./rankCourse.vue";
import rankSchool from "./rankList/rankSchool.vue";
import rankCourse from "./rankList/rankCourse.vue";
import rankTeacher from "./rankList/rankTeacher.vue";
// import rankStudent from "./rankList/rankStudent.vue";
import { setTimeout } from "timers";

export default {
  components: {
    school,
    live,
    hotCourse,
    recommend,
    hotTeacher,
    rankSchool,
    rankCourse,
    rankTeacher,
    // rankStudent,
  },
  data() {
    return {
      posFlag:true,
      bannerList: [],
      newsList: [],
      imgUrl: this.$setting.fdsDomain,
      schoolFlag: true,
      liveFlag: true,
      recommendFlag: true,
      teacherFlag: true,
      categoryId: "-1",
      categoryOptions: [],
      categoryFlag: [],
      categoryEight: [],
      iconFlag: false,
      liveList: [],
      onlineData: 0,
      allCount: {
        moocCourse: 0,
        moocCount: 0,
        spocCount: 0,
        spocCourse: 0,
        allCount: 0,
      },
      dataCounts: {},
      subjectList:[],
      listTag:[],
      indexBanner: null
    };
  },
  watch: {},
  mounted() {
    this.getbanner();
    this.getNews();
    this.getCount();
    this.getCategoryList();
    this.online();
    this.setOnLone();
    this.getSubject();
    this.getTagList();
    this.getIndexBanner();
    // ============
  },
  methods: {
    getIndexBanner(){
      this.$http
        .post("/api/web/indexBanner/getInfo")
        .then((res) => {
          this.indexBanner = res.data;
        })
        .catch((msg) => {});
    },
    // =================
    toTagIndex(val) {
      this.$message.warning("该子站尚未开通，敬请期待！");
    },
    toChildIndex(val) {
      window.open(`/childIndex?siteId=${val}`);
      localStorage.setItem("pathKey", val);
    },
    torural(val){
      console.log(this.$router);
      window.open(`/ruralIndex?siteId=${val}`);
      localStorage.setItem("pathKey", val);
    },
    toIndexBannerLink(){
      if(this.indexBanner.linkUrl){
        window.open(this.indexBanner.linkUrl);
      }
    },
    openCourse(key, keyPath) {
      window.open(
        `/course?pathFalg=new&categoryId=${key}&tagCourseId=&collegeId=&tagProjectId=&status=&key=`
      );
    },
    // 在线人数看板，
    online() {
      this.$http
        .post("/api/web/sys/online")
        .then((res) => {
          this.onlineData = res.data.online;
        })
        .catch((msg) => {});
    },
    // 5分钟刷新在线人数
    setOnLone() {
      window.setInterval(() => {
        this.online();
      }, 300000);
    },
    //获取分类列表
    getCategoryList() {
      let par = {
        type: 1,
        showHide: 1,
        isTree: 0,
      };
      this.$http
        .post("api/manage/category/courseList", par)
        .then((res) => {
          let item = res.data;
          let list = [];
          let obj = {};
          for (let i = 0; i < 8; i++) {
            if (i < item.length && item[i].layer == 0) {
              let val = {
                title: item[i].title,
                id: item[i].id,
              };
              list.push(val);
            }
          }
          // if (item && item.length > 7) {
          //   for (let j = 8; j < item.length; j++) {
          //     let valFlag = {
          //       title: item[j].title,
          //       id: item[j].id,
          //     };
          //   }
          // }
          this.categoryFlag = res.data;
          list.push({
            title: "更多课程",
            id: "",
          });
          obj = {
            title: "更多课程",
            id: "",
          };
          this.categoryEight = list;
          this.categoryFlag.push(obj);
          this.categoryOptions = list;
        })
        .catch((msg) => {});
    },
    getDelMenu() {
      if (!!this.iconFlag) {
        this.iconFlag = false;
        this.categoryOptions = this.categoryEight;
      }
    },
    getClear() {
      this.iconFlag = false;
      this.categoryOptions = this.categoryEight;
    },
    getAll() {
      this.iconFlag = true;
      this.categoryOptions = this.categoryFlag;
    },

    getSchool(val) {
      this.schoolFlag = val;
    },
    getlive(val) {
      this.liveFlag = val;
    },
    getRecommend(val) {
      this.recommendFlag = val;
    },
    getTeacher(val) {
      this.teacherFlag = val;
    },

    toCourseList(val) {
      // window.location.href = `/course`;
      window.open(
        `/course?pathFalg=${val}&categoryId=&columnId=&school=&isOnline=3&status=&key=`
      );
    },
    toTeacherList(val) {
      // window.location.href = `/teacher`;
      window.open(`/teacher`);
    },
    toNewsList(val) {
      // window.location.href = `/news`;
      window.open(`/news`);
    },
    toNewsDetail(val) {
      // window.location.open = `/news/newsDetail?id=${val}`;
      window.open(`//news/newsDetail?id=${val}`);
    },
    getbanner() {
      this.$http
        .post("/api/web/banner/list", { tagCourseId: "0" })
        .then((res) => {
          this.bannerList = res.data;
          this.sysCountPV();
        });
    },
    sysCountPV() {
      this.$http.post("/api/web/sys/sysCountPV");
    },
    getNews() {
      let par = {
        pageSize: 8,
        currentPage: 1,
      };
      this.$http.post("/api/web/article/newList", par).then((res) => {
        this.newsList = res.data.records;
      });
    },
    getCount() {
      this.$http.post("/api/web/index/getIndexCount").then((res) => {
        this.dataCounts = res.data;
      });
    },

    // 获取首页推荐卡片轮播
    getSubject() {
      this.$http.get("/api/web/subject/list").then((res) => {
        this.subjectList = res.data||[];
      });
    },
    // 获取课程层次list
    getTagList() {
      let par = {
        type: 'COURSE',
      };
      this.$http
        .get("api/manage/tag/list", { params: par })
        .then((res) => {
          this.listTag = res.data;
        })
        .catch((msg) => {});
    },
  },
};
</script>
<style lang="scss">
.pos-flex{
  position: fixed;
  top: 50%;
  right: 30px;
  width: 156px;
  height: 230px;
  z-index: 99999;
  cursor: pointer;
  .pos-con{
    position: relative;
    .pos-close{
      position: absolute;
      top: -18px;
      right: -18px;
      width: 20px;
      height: 20px;
      i{
        font-size: 20px;
        &:hover{
          color: #3685fd;
        }
      }

    }
    .pos-msg{
      // background: url(/images/pos_flexd.png) top no-repeat;
      // background-size: cover;
      width: 156px;
      height: 230px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
.data-count {
  .data-body {
    ul {
      width: 1200px;
      margin: 0 auto;
      li {
        width: 299px;
        padding: 20px 0 40px 0;
        float: left;
        align-items: center;
        text-align: center;
        .item-icon {
          width: 50px;
          height: 40px;
          margin: auto;
          font-size: 30px;
          color: #3685fdff;
          &.item-icon1 {
            background: url(/images/data_type1.png) top no-repeat;
            background-size: cover;
          }
          &.item-icon2 {
            background: url(/images/data_type2.png) top no-repeat;
            background-size: cover;
          }
          &.item-icon3 {
            background: url(/images/data_type3.png) top no-repeat;
            background-size: cover;
          }
          &.item-icon4 {
            background: url(/images/data_type4.png) top no-repeat;
            background-size: cover;
          }
        }
        .item-border {
          font-size: 36px;
          font-weight: bold;
          border-right: solid 1px #ddddddff;
        }
        .item-noborder {
          border-right: none;
        }
        .item-title {
          font-size: 12px;
          color: #333;
        }
      }
    }
  }
}
.child-body {
  width: 1200px;
  margin: 0 auto;
  .child-box {
    padding: 40px 0 30px;

    .child-content {
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        li {
          flex: 1;
          max-width: 278px;
          min-width: 278px;
          height: 120px;
          background: #ccc;
          border-radius: 4px;
          position: relative;
          img{
            width: 100%;
            height: 100%;
            transition: all 0.2s ease-in-out;
            border-radius: 4px;
            cursor: pointer;
          }

          .item-bg {
            position: absolute;
            top: 0;
            left: 0;
            background: #000;
            opacity: 0.5;
            width: 278px;
            height: 120px;
            border-radius: 4px;
          }
          .item-con {
            top: 0;
            left: 0;
            position: absolute;
            color: #fff;
            z-index: 1;
            line-height: 120px;
            width: 278px;
            height: 120px;
            text-align: center;
            border-radius: 4px;
          }
          &.child-type1 {
            background: url(/images/school_type1.png) top no-repeat;
            background-size: cover;
            cursor: pointer;
          }
          &.child-type2 {
            background: url(/images/school_type2.png) top no-repeat;
            background-size: cover;
            cursor: pointer;
          }
          &.child-type3 {
            background: url(/images/school_type3.png) top no-repeat;
            background-size: cover;
          }
          &.child-type4 {
            background: url(/images/school_type4.png) top no-repeat;
            background-size: cover;
          }
        }
      }
    }
  }
}
.con-menu {
  width: 1200px;
  position: relative;
  margin: 0 auto;
  .con-nav-list {
    position: absolute;
    left: 0;
    top: 0px;
    width: 210px;

    ul {
      padding: 11px 0;
      position: absolute;
      width: 210px;
      background: #fff;
      z-index: 100;
      opacity: 0.85;
      li {
        color: #333;
        line-height: 42px;
        height: 42px;
        border-radius: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 20px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.is-active {
          color: #3685fdff;
          background: #ebf3ffff;
        }
        &:hover {
          color: #3685fdff;
          background: #ebf3ffff;
        }
      }
    }
  }
  .pos-black-bg {
    position: absolute;
    right: 0;
    top: 50px;
    z-index: 10;
    background: #000000ff;
    opacity: 0.4;
    height: 305px;
    width: 250px;
    border-radius: 8px;
  }
  .pos-black {
    position: absolute;
    right: 0;
    top: 50px;
    z-index: 11;
    height: 305px;
    width: 250px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    .pos-news {
      ul {
        width: 250px;
        height: 305px;
        z-index: 100;
        padding: 20px;
        border-radius: 4px;
        li {
          width: 100%;
          font-size: 14px;
          line-height: 30px;

          cursor: pointer;
          a {
            display: block;
            color: #fff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &:hover {
              color: #3685fd;
            }
          }
        }
        .pos-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 5px;
          padding: 0 0 10px 0;
          h3 {
            color: #fff;
            font-size: 16px;
          }
          span {
            font-size: 14px;
            color: #fff;
            cursor: pointer;
          }
          span:hover {
            color: #3685fd;
          }
        }
      }
    }
  }
}
.con-banner {
  height: 400px;
  width: 100%;
  margin: 0 auto;
  // overflow: hidden;
  display: flex;
  justify-content: space-between; // position: relative;

  .el-carousel {
    flex: 1;
    overflow: hidden;
    .el-carousel__container {
      margin: 0 auto;
      .item-con {
        position: relative;
        width: auto;
        height: 400px;
        margin: 0 auto;
      }
    }
  }

  .el-carousel__item img {
    // width: 100%;
    height: 100%;
    margin: 0 auto;
    display: block;
  }
  &.subjectList{
    width: 1200px;
    height: 100px;
    margin-top: 20px;
    .el-carousel {
       border-radius: 8px;
    .el-carousel__container {
      .item-con {
        position: relative;
        width: 1200px;
        height: 100px;
        margin: 0 auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  }
}
// 乡村振兴
.rural-promote {
  width: 1200px;
  margin: 20px auto 0 auto;
  cursor: pointer;
  display: none;
  img{
    width: 100%;
  }
}
.school-body {
  background: #f7f8f9;
  .school-box {
    width: 1200px;
    padding: 40px 0 30px;
    margin: 0 auto;
  }
}
.course-body {
  background: #fff;
  .course-box {
    width: 1200px;
    padding: 40px 0px;
    margin: 0 auto;
  }
}
.hotCourse-body {
  // background: #fff;
  .hotCourse-box {
    width: 1200px;
    padding: 50px 0 0 0;
    margin: 0 auto;
  }
}
.hotTeacher-body {
  background-image: url(/images/index_bg.png);
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  .hotTeacher-box {
    width: 1200px;
    padding: 50px 0 60px 0;
    margin: 0 auto;
    .hotTeacher-tool {
      h2,
      span {
        color: #fff;
      }
      span:hover {
        color: #3685fd;
      }
    }
  }
}
.slort-body {
  background: #fff;
  .slort-box {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    .slort-content {
      display: flex;
      margin-top: 20px;
    }
  }
}
.body-tool {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h2 {
    font-size: 26px;
  }
  span {
    font-size: 14px;
    color: #777;
    cursor: pointer;
    &:hover {
      color: #3685fd;
    }
  }
}
</style>
